/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Results_No_ListeningInputs */

const en_onboarding_results_no_listening = /** @type {(inputs: Onboarding_Results_No_ListeningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No listening`)
};

const es_onboarding_results_no_listening = /** @type {(inputs: Onboarding_Results_No_ListeningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin escuchar`)
};

/**
* | output |
* | --- |
* | "No listening" |
*
* @param {Onboarding_Results_No_ListeningInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_results_no_listening = /** @type {((inputs?: Onboarding_Results_No_ListeningInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Results_No_ListeningInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_results_no_listening(inputs)
	return en_onboarding_results_no_listening(inputs)
});